import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import SharedTools from '../../lib/SharedTools';
import StringHelper from '../../lib/StringHelper';
import DataService from '../../lib/DataService';
import ImageViewModal from '../share/ImageViewModal';
import UpdatePostModule from './UpdatePostModule';
import { Modal, message, Icon, Input, Button, Popconfirm } from 'antd';
const { TextArea } = Input;
const confirm = Modal.confirm;

export default class Post extends React.Component {
  static propTypes = {
    post: PropTypes.object.isRequired,
    onDestroyPost: PropTypes.func
  };

  constructor(props) {
    super(props);
    // set state
    this.state = {
      post: props.post,
      userRoleInfo: props.userRoleInfo,

      isShowDeletePostDialog: false,
      isDeleting: false,
      isShowPhotosDialog: false,
      photoIndex: 0,
      liked: false,
      likedList: [],
      comments: [],
      isShowEditCommentDialog: false,
      comment: '',
      placeholder: "评价",
      replyToId: null,
      replyToRole: '',

      isShowEditPostDialog: false,
      isDeleting: false
    };
    // bind this
    this.dateTranslate = this.dateTranslate.bind(this);
    this.toggleOpenDeletePostDialog = this.toggleOpenDeletePostDialog.bind(this);
    this.toggleOpenPhotosDialog = this.toggleOpenPhotosDialog.bind(this);
    this.onDestroyPost = this.onDestroyPost.bind(this);
    this.likePost = this.likePost.bind(this);
    this.dislikePost = this.dislikePost.bind(this);
    this.showEditBox = this.showEditBox.bind(this);
    this.hideEditBox = this.hideEditBox.bind(this);
    this.inputComment = this.inputComment.bind(this);
    this.submitComment = this.submitComment.bind(this);
    this.handleReply = this.handleReply.bind(this);
    this.handleAllComments = this.handleAllComments.bind(this);
    this._likesCommentsView = this._likesCommentsView.bind(this);

    this.toggleOpenEditPostDialog = this.toggleOpenEditPostDialog.bind(this);
    this.onDestroyPost = this.onDestroyPost.bind(this);
  }

  componentDidMount() {
    if (this.state.post.video) {
      var element = ReactDOM.findDOMNode(this.videoObj);
      element.setAttribute('controlsList', 'nodownload');
    }
    let userId = this.state.userRoleInfo.id;
    let likes = this.state.post.likes;
    let comments = this.state.post.comments;
    let liked = this.state.liked;
    let likedList = this.state.likedList;
    let likedId;
    let role = this.state.post.role;
    let name = this.state.post.author_name;
    this.state.post.author_name = StringHelper.addRoleName(role,name);


    likes.forEach(function(like, index){
      if(like.author_id == userId){
        likedList.unshift(like.author_name)
        liked = true;
        likedId = like.id
      }else {
        likedList.push(like.author_name);
      }
    })
    comments.forEach(function(comment){
      comment.reply_to_full_name = SharedTools.addRoleName(comment.reply_to_role, comment.reply_to_full_name)
      comment.author_full_name = SharedTools.addRoleName(comment.author_role, comment.author_full_name)
    })

    this.setState({
      post: this.state.post,
      likedList: likedList,
      liked: liked,
      likedId: likedId,
      comments: this.state.post.comments.length > 6 ? this.state.post.comments.slice(0,[7]) : this.state.post.comments
   })
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      post: newProps.post,
      userRoleInfo: newProps.userRoleInfo
    });
  }

  // Tools
  dateTranslate(date) {
    // return date;
    let currentTime = new Date();
    let createdTime = SharedTools.strToDate(date);
    createdTime.setTime(createdTime.getTime() + 28800000);
    let formatTime = `${SharedTools.formatNumber(createdTime.getMonth() + 1)}-${SharedTools.formatNumber(createdTime.getDate())} ${SharedTools.formatNumber(createdTime.getHours())}:${SharedTools.formatNumber(createdTime.getMinutes())}`; // date.slice(5, 16).replace(/-/g, '-');
    let yearsDiff = currentTime.getFullYear() - createdTime.getFullYear();
    let daysDiff = (currentTime - createdTime) / (60 * 60 * 24 * 1000)
    if (yearsDiff > 0) {
      return yearsDiff + "年前"
    } else if (daysDiff > 4) {
      return formatTime
    } else if (daysDiff > 3) {
      return "3天前"
    } else if (daysDiff > 2) {
      return "2天前"
    } else if (daysDiff > 1) {
      return "1天前"
    } else {
      let hour = daysDiff * 24
      if (hour > 1) {
        return parseInt(hour) + "小时前"
      } else if (hour > 0.05) {
        return parseInt(hour * 60) + "分钟前"
      } else if (hour > 0){
        return "刚刚"
      }
    }
  }

  // Events
  toggleOpenDeletePostDialog() {
    this.setState({
      isShowDeletePostDialog: !this.state.isShowDeletePostDialog
    })
  }

  toggleOpenEditPostDialog() {
    this.setState({
      isShowEditPostDialog: !this.state.isShowEditPostDialog
    })
  }

  onDestroyPost() {
    this.setState({isDeleting: true});
    if (this.state.userRoleInfo && this.state.userRoleInfo.id === this.state.post.author_id)
      DataService.destroyPost(this.state.post.id).then((response) => {
        this.setState({isDeleting: false, isShowDeletePostDialog: false});
        // call parent component to update view
        this.props.onDestroyPost(this.state.post.id);
      }, (error) => {
        message.error('删除新鲜事失败');
        this.setState({isDeleting: false, isShowDeletePostDialog: false});
      });
  }

  toggleOpenPhotosDialog(e) {
    let photoIndex = parseInt(e.currentTarget.dataset.index);
    if(e.currentTarget.dataset.photos) {
      this.state.post.photos = JSON.parse(e.currentTarget.dataset.photos)
      this.state.post.tags_count = e.currentTarget.dataset.type == "addTag" ? this.state.post.tags_count + 1 : (e.currentTarget.dataset.type == "removeTag" ? this.state.post.tags_count - 1 : this.state.post.tags_count);
    }

    this.state.isShowPhotosDialog ? document.body.style.overflow = 'auto' : document.body.style.overflow = 'hidden'
    
    this.setState({
      isShowPhotosDialog: !this.state.isShowPhotosDialog,
      photoIndex: photoIndex,
      post: this.state.post
    })
  }

  likePost() {
    let data = {
      post_id: this.state.post.id,
      role: this.state.userRoleInfo.roleName
    }
    DataService.addPostLikes(data).then((response) => {
      response.author_name = SharedTools.addRoleName(response.author_role, response.author_name);
      this.state.post.likes.unshift(response);
      this.state.likedList.unshift(response.author_name);
      this.props.updatePosts(this.state.post);
      this.setState({
        liked: true,
        likedId: response.id,
        likedList: this.state.likedList,
        post: this.state.post
      })
    }, (error) => {
      message.error('点赞失败');
    });
  }

  dislikePost() {
    DataService.deletePostLikes(this.state.likedId).then((response) => {
      this.state.post.likes.shift();
      this.state.likedList.shift();
      this.props.updatePosts(this.state.post);
      this.setState({
        liked: false,
        likedList: this.state.likedList,
        post: this.state.post
      })
    }, (error) => {
      message.error('取消点赞失败');
    });
  }

  showEditBox() {
    this.setState({
      isShowEditCommentDialog: true
    })
  }

  hideEditBox() {
    if(!this.state.comment){
      this.setState({
        isShowEditCommentDialog: false,
        placeholder: "评价",
        replyToId: null,
        replyToRole: '',
      })
    }
  }

  inputComment(e) {
    let comment = e.target.value;
    this.setState({
      comment: comment
    })
  }

  handleReply(e) {
    let commentId = e.currentTarget.dataset.id;
    let comment = this.state.post.comments.find(function(comment){return comment.id == commentId})
    let that = this;
    if(comment.author_id == this.state.userRoleInfo.id){
      confirm({
        title: '确认删除这条评论？',
        okText: '确认',
        okType: 'primary',
        cancelText: '取消',
        onOk() {
          DataService.deletePostComment(commentId).then((response) => {
            that.state.post.comments = that.state.post.comments.filter(function(comment){
              return comment.id != commentId
            })
            that.props.updatePosts(that.state.post);
            that.setState({
              post: that.state.post,
              comments: (that.state.comments.length - 1 ) == that.state.post.comments.length ? that.state.post.comments : that.state.post.comments.slice(0,[7]),
              isShowEditCommentDialog: false,
            })
          }, (error) => {
            message.error('删除失败');
          });
        },
        onCancel() {
          if(!that.state.comment){
            that.setState({
              isShowEditCommentDialog: false,
            })
          }
        }
      });
    }else {
      this.setState({
        placeholder: "回复" + comment.author_full_name,
        replyToId: comment.author_role_id,
        replyToRole: comment.author_role.toLowerCase(),
        isShowEditCommentDialog: true
      })
    }
  }

  submitComment() {
    if(this.state.comment){
      let data = {
        post_id: this.state.post.id,
        text: this.state.comment,
        role: this.state.userRoleInfo.roleName,
        reply_to_id: this.state.replyToId,
        reply_to_role: this.state.replyToRole,
      }
      DataService.addPostComment(data).then((response) => {
        response.reply_to_full_name = SharedTools.addRoleName(response.reply_to_role, response.reply_to_full_name)
        response.author_full_name = SharedTools.addRoleName(response.author_role, response.author_full_name)
        this.state.post.comments.push(response)
        this.props.updatePosts(this.state.post);
        this.setState({
          post: this.state.post,
          comments: this.state.post.comments,
          comment: '',
          replyToId: null,
          replyToRole: '',
          placeholder: "评价",
          isShowEditCommentDialog: false
        })
      }, (error) => {
        message.error('发布失败');
      });
    }
  }

  handleAllComments() {
    this.setState({
      comments: this.state.comments.length == this.state.post.comments.length ? this.state.post.comments.slice(0,[7]) : this.state.post.comments
    })
  }

  _likesCommentsView() {
    return (
      <div className="likes-comments">
        <div className="likes-comments-header">
          <div className="likes-comments-record">已有{this.state.post.tags_count}人收入宝贝相册</div>
          { this.state.post.is_visible && <div className="likes-comments-record-img"></div>}
          <div className="likes-comments-comments-img" onClick={this.showEditBox}></div>
          {!this.state.liked &&
            <Icon type="like" className="likes-comments-like-img" onClick={this.likePost}/>
          }
          {this.state.liked &&
            <Icon type="like" className="likes-comments-like-img" style={{ color: '#08c' }}  onClick={this.dislikePost}/>
          }
        </div>
        <div className="likes-comments-box">
          <div className="likes">
            {!this.state.liked && this.state.likedList.length > 0 &&
              <Icon type="like" className="likes-img"/>
            }
            {this.state.liked && this.state.likedList.length > 0 &&
              <Icon type="like" className="likes-img" style={{ color: '#08c' }}/>
            }
            <div className="likes-list">{this.state.likedList.join("，")}</div>
          </div>
          {this.state.comments.map((comment)=>
            <div className="comments" key={comment.id}>
              {!comment.reply_to_full_name &&
                <div className="comments-content" onClick={this.handleReply} data-id={comment.id}><span>{comment.author_full_name}</span><span>：{comment.text}</span></div>
              }
              {comment.reply_to_full_name &&
                <div className="comments-content" onClick={this.handleReply} data-id={comment.id}><span>{comment.author_full_name}</span>回复<span>{comment.reply_to_full_name}</span><span>：{comment.text}</span></div>
              }
              {(comment.author_id == this.state.userRoleInfo.id) &&
                <Icon type="delete" className="comment-tip" onClick={this.handleReply} data-id={comment.id} />
              }
              {(comment.author_id != this.state.userRoleInfo.id) &&
                <Icon type="message" className="comment-tip" onClick={this.handleReply} data-id={comment.id} />
              }
            </div>
          )}
          {this.state.post.comments.length > 7 &&
            <div className="comment-more" onClick={this.handleAllComments}>
              {this.state.comments.length < this.state.post.comments.length ? '查看更多' : '收起'}<Icon type={this.state.comments.length < this.state.post.comments.length ? 'down' : 'up'} style={{ color: '#4DA1FF' }} />
            </div>
          }
          {this.state.isShowEditCommentDialog &&
            <div className="comment-input-box">
              <Input className="comment-input" autoFocus={true} placeholder={this.state.placeholder} onChange={this.inputComment} onBlur={this.hideEditBox}/>
              <Button className="comment-btn" type="primary" onClick={this.submitComment}>发布</Button>
            </div>
          }
        </div>
      </div>
    )
  }

  render() {
    let post = this.state.post;
    let author = post.author;
    let hasAvatar = (author.parent_record && author.parent_record.avatar_url) || (author.teacher_record && author.teacher_record.avatar_url);
    return (
      <div className="post-container">
        <div className={"avatar" + (!hasAvatar ? " default-avatar" : '')}>
          {hasAvatar &&
            <img className="customed-avatar" src={author.parent_record && author.parent_record.avatar_url ? author.parent_record.avatar_url : author.teacher_record.avatar_url} /> }
        </div>

        <div className="content">
          <div className="author-name">{post.author_name}</div>
          <div className="record-date">{this.dateTranslate(post.record_date)}</div>
          <div className="text">{post.text}</div>

          {post.photos && post.photos.length === 1 &&
            <div className="single-photo-container">
              <img className="photo" src={SharedTools.getMediumImageUrl(post.photos[0].remote_url)} onClick={this.toggleOpenPhotosDialog} data-index={0}/>
            </div>
          }
          {post.photos && post.photos.length > 1 && post.photos.map((photo, index) =>
            <div key={photo.id} className={"photo-container" + ([5, 6, 9].indexOf(post.photos.length) < 0 && index % 4 == 3 ? " no-right-margin" : "")}>
              <img className="photo" src={SharedTools.getThumbImageUrl(photo.remote_url)} onClick={this.toggleOpenPhotosDialog} data-index={index} />
            </div>
          )}
          {post.video &&
            <video ref={(video) => {this.videoObj = video;}}
              height="220" controls>
              <source src={post.video.remote_url} type="video/mp4" />
              你的浏览器不支持播放视频
            </video>
          }

          {this._likesCommentsView()}
        </div>

        {this.state.userRoleInfo && this.state.userRoleInfo.id === post.author_id && this.state.userRoleInfo.roleName === post.role &&
          <div className="actions">
            <div className="three-bullets"></div>
            <div className="menu-container">
              <div className="menu">
                <div className="item" onClick={this.toggleOpenEditPostDialog}>编辑</div>
                <div className="item" onClick={this.toggleOpenDeletePostDialog}>删除</div>
              </div>
            </div>
          </div>
        }

        <Modal title="删除新鲜事"
          visible={this.state.isShowDeletePostDialog}
          onOk={this.onDestroyPost}
          confirmLoading={this.state.isDeleting}
          onCancel={this.toggleOpenDeletePostDialog}
        >
          <p>删除内容后新鲜事也一并从宝贝相册中消失</p>
        </Modal>

        {this.state.isShowPhotosDialog &&
          <ImageViewModal type="album" postId={this.state.post.id} userRoleInfo={this.state.userRoleInfo} photos={this.state.post.photos} photoIndex={this.state.photoIndex} onCancel={this.toggleOpenPhotosDialog} />
        }

        {this.state.isShowEditPostDialog && <UpdatePostModule userRoleInfo={this.state.userRoleInfo} postContent={this.state.post} successCallBack={this.toggleOpenEditPostDialog} updatePosts={this.props.updatePosts} />}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/album/Post.jsx